module.exports = __webpack_public_path__ + "static/media/facebook.ac416020.svg";